import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';

function optionAttributes(options) {
  const optionData = options.map((index, optionEl) => ({
    id: $(optionEl).data('id'),
    tekst: $(optionEl).data('tekst'),
    position: index,
  }));
  return optionData.toArray();
}

function updateOptionPositions() {
  $('.js-poll-option-position').each((index, optionEl) => {
    $(optionEl).val(index);
  });
}

$(() => {
  const optionsList = $('.js-poll-options');
  const peilingId = optionsList.data('peiling-id');
  const serieSlug = optionsList.data('serie-slug');

  optionsList.sortable({ items: '.js-poll-option' }).on('sortupdate', () => {
    $.ajax({
      url: $('.js-poll-option').data('url'),
      contentType: 'application/json',
      method: 'PUT',
      data: JSON.stringify(
        {
          subsiteadmin_slug: serieSlug,
          id: peilingId,
          peiling: {
            keuzes_attributes: optionAttributes($('.js-poll-option')),
          },
        },
      ),
    });
    updateOptionPositions();
  });

  $('#keuzes').on('cocoon:after-insert', updateOptionPositions);
});
